import React from 'react';
import { AllieImg, AllieText } from '@allie/app-ui-lib';
import { CreateLoadingContainer } from './CreateLoading.styles';
import { isMobile } from '../../../../helpers/utils';
import { useAppTranslations } from '../../../../hooks/useAppTranslations';

const namespace = 'create-loading';

export const CreateLoading: React.FC = () => {
  const { RESET_LOADING_SUBTITLE, RESET_LOADING_TITLE } = useAppTranslations();

  return (
    <CreateLoadingContainer isMobile={isMobile}>
      <AllieText type="h3">{RESET_LOADING_TITLE}</AllieText>
      <div className={`${namespace}-gif`}>
        <AllieImg src="assets/change-password-loading.gif" />
      </div>
      <div className={`${namespace}-body`}>
        <AllieText type="body1" color="neutral-50">
          {RESET_LOADING_SUBTITLE}
        </AllieText>
      </div>
    </CreateLoadingContainer>
  );
};
